var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"beatmap-card"},[_vm._t("default"),_c('img',{staticClass:"beatmap-card--background",attrs:{"src":_vm.backgroundSource}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }